import Config from '@config';
import { initializeEquipmentManufacturerApi } from '@gasbi/shared/common/features/equipmentManufacturer';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  equipmentManufacturerApi,
  useCreateEquipmentManufacturerMutation,
  useUpdateEquipmentManufacturerMutation,
  useGetEquipmentManufacturersInfiniteQuery,
} = initializeEquipmentManufacturerApi(Config.VITE_API_URL, axiosBaseQuery);
